import PersonAvatar from 'Containers/Teleconsult/Sidebar/List/ChatListGroup/PersonAvatar';
import moment from 'moment';
import { bool, func, shape } from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getConversationById } from 'Selectors/webChat/consults';
import { Image, List, Segment } from 'semantic-ui-react';

import ContextMenuHeader from './ContextMenuHeader';

class ConsultDetails extends Component {
  render() {
    const { conversationActive, closeContextMenu, isFetching } = this.props;
    const {
      patient,
      forPatient,
      latestConsult: { reason, medicalConditions, drugAllergies, createdAt },
    } = conversationActive;
    return (
      <Segment.Group className="context-menu">
        <ContextMenuHeader title="Consult Details" closeContextMenu={closeContextMenu} />
        <Segment className="body" loading={isFetching}>
          {!isFetching && (
            <List relaxed="very" className="consult-details">
              <List.Item>
                <List.Header>FOR PATIENT</List.Header>
                <List.List>
                  <List.Item>
                    <PersonAvatar data={forPatient} />
                    <List.Content verticalAlign="middle">{forPatient.fullName}</List.Content>
                  </List.Item>
                </List.List>
              </List.Item>
              <List.Item>
                <List.Header>REQUESTED BY</List.Header>
                <List.List>
                  <List.Item>
                    <Image avatar src={patient.avatarUrl} />
                    <List.Content verticalAlign="middle">{patient.fullName}</List.Content>
                  </List.Item>
                </List.List>
              </List.Item>
              <List.Item>
                <List.Header>ON</List.Header>
                <List.List>
                  <List.Item>
                    <List.Icon name="calendar outline" />
                    <List.Content verticalAlign="middle">
                      {moment(createdAt).format('MMMM D, YYYY')}
                    </List.Content>
                  </List.Item>
                </List.List>
              </List.Item>
              <List.Item>
                <List.Header>REASON FOR CONSULTATION</List.Header>
                <List.Content className="reason">{reason}</List.Content>
              </List.Item>
              <List.Item>
                <List.Header>PRE-EXISTING MEDICAL CONDITIONAL</List.Header>
                <List.Content className="reason">{medicalConditions}</List.Content>
              </List.Item>
              <List.Item>
                <List.Header>DRUG ALLERGY</List.Header>
                <List.Content className="reason">{drugAllergies}</List.Content>
              </List.Item>
            </List>
          )}
        </Segment>
      </Segment.Group>
    );
  }
}

ConsultDetails.propTypes = {
  closeContextMenu: func.isRequired,
  conversationActive: shape({}).isRequired,
  isFetching: bool.isRequired,
};

const mapStateToProps = state => ({
  conversationActive: getConversationById(state, state.webChat.conversationActive),
});

export default connect(mapStateToProps)(ConsultDetails);
